import ExcelJS from "exceljs";

const HEADER_FILL = "FFF3F6F8";

export const exportTimeManagementExcel = async ({
  elementList,
  fileName,
  sheetName = "รายงาน",
  wrapColumns = [],
}) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(sheetName);

  const columnKeys = elementList.length > 0 ? Object.keys(elementList[0]) : [];
  worksheet.columns = columnKeys.map((key) => ({
    header: key,
    key,
    width: key === "เหตุผลลางาน" ? 32 : wrapColumns.includes(key) ? 24 : 20,
  }));

  const headerRow = worksheet.getRow(1);
  headerRow.height = 30;
  headerRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: HEADER_FILL } };
  });

  worksheet.views = [{ state: "frozen", ySplit: 1 }];

  elementList.forEach((element) => {
    const row = worksheet.addRow(element);
    let maxLines = 1;
    columnKeys.forEach((key) => {
      const cell = row.getCell(key);
      if (wrapColumns.includes(key)) {
        cell.alignment = {
          wrapText: true,
          vertical: "top",
          horizontal: key === "เหตุผลลางาน" ? "left" : "center",
        };
        const lines = String(cell.value || "").split("\n").length;
        if (lines > maxLines) maxLines = lines;
      } else {
        cell.alignment = { vertical: "middle", horizontal: "center" };
      }
    });
    row.height = Math.max(20, maxLines * 15);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
};
